import { Button, Chip, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import { compact, isEmpty, values } from 'lodash';
import { filterReceivings } from 'store/thunks/stockManagementThunk';

const StockManagementFilterStatusBar = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ inventory }) => inventory.stockManagement.filter);

  const removeFilter = (key) => () =>
    dispatch(filterReceivings({ filter: { ...filter, [key]: undefined } }));

  const removeAll = () =>
    dispatch(
      filterReceivings({
        filter: {
          vendorName: undefined,
          manifestReference: undefined,
          status: undefined,
          receivedDateFrom: undefined,
          receivedDateTo: undefined,
        },
      })
    );

  const hasFilters = !isEmpty(compact(values(filter)));

  const dateRangeLabel = (() => {
    const from = filter.receivedDateFrom
      ? format(new Date(filter.receivedDateFrom), 'MM/dd/yyyy')
      : null;
    const to = filter.receivedDateTo ? format(new Date(filter.receivedDateTo), 'MM/dd/yyyy') : null;
    if (from && to) return `Received Date: ${from} – ${to}`;
    if (from) return `Received Date: From ${from}`;
    return `Received Date: To ${to}`;
  })();

  return (
    <Stack direction='row' spacing={0.75} flexWrap='wrap' alignItems='center'>
      {filter.vendorName && (
        <Chip
          size='small'
          label={`Vendor = ${filter.vendorName}`}
          variant='contained'
          onDelete={removeFilter('vendorName')}
        />
      )}
      {filter.manifestReference && (
        <Chip
          size='small'
          label={`Manifest = ${filter.manifestReference}`}
          variant='contained'
          onDelete={removeFilter('manifestReference')}
        />
      )}
      {filter.status && (
        <Chip
          size='small'
          label={`Status = ${filter.status.replace(/_/g, ' ')}`}
          variant='contained'
          onDelete={removeFilter('status')}
        />
      )}
      {(filter.receivedDateFrom || filter.receivedDateTo) && (
        <Chip
          size='small'
          label={dateRangeLabel}
          variant='contained'
          onDelete={() =>
            dispatch(
              filterReceivings({
                filter: { ...filter, receivedDateFrom: undefined, receivedDateTo: undefined },
              })
            )
          }
        />
      )}
      {hasFilters && (
        <Button size='small' onClick={removeAll} sx={{ fontSize: 12 }}>
          Remove All
        </Button>
      )}
    </Stack>
  );
};

export default StockManagementFilterStatusBar;
